import React, { Component } from 'react';
import classNames from 'classnames';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Checkout from './Checkout';
import TargetTab from './TargetTab';
import PaymentTab from './PaymentTab';
// import ScheduleTab from './ScheduleTab';

import SMSPreview from './previews/SMSPreview';

const Content = ({
  body,
  handleChange,
}) => (
  <div>
    <div>
      {/* <input className="input" type="text" 
        name="subject"
        placeholder="Subject"
        onChange={handleChange}/> */}
      <div>
        <textarea className="textarea" rows="8" maxLength="160"
          name="body"
          placeholder="Text Message"
          value={body}
          onChange={handleChange}/>
        { body && <div className="sub">{ body.length } / 160</div> }
      </div>
    </div>
  </div>
)

class SMSCampaign extends Component {
  state = {
    body: 'Hi there!',
    country: '',
    city: '',
    segment: '',
    orderName: '',
    sendDate: '',
    eventDate: '',
    checkout: false,
  }

  handleChange = (ev) => {
    const name = ev.target.name;
    const value = ev.target.value;

    this.setState({ [name]: value })
  }

  showCheckout = (ev) => {
    this.setState({ checkout: !this.state.checkout })
  }

  render() {
    const campaign__sidebar = classNames('campaign__sidebar', { 'campaign__sidebar--disable': this.state.checkout });
    return (
      <div className="campaign">
        <div className={campaign__sidebar}>
          <Tabs>
            <TabList className="campaign__tabs">
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">SMS Campaign</Tab>
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Target</Tab>
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Order</Tab>
            </TabList>
            <TabPanel>
              <Content 
                body={this.state.body}
                handleChange={this.handleChange} />
            </TabPanel>
            <TabPanel>
              <TargetTab
                state={this.state}
                handleChange={this.handleChange} />
            </TabPanel>
            <TabPanel>
              <PaymentTab
                state={this.state}
                handleChange={this.handleChange} 
                showCheckout={this.showCheckout} />
            </TabPanel>
          </Tabs>
          {/* <div className="campaign__buttons">
            <button className="button" onClick={this.props.hideModal}>Close</button>
            <button className="button">Save</button>
          </div> */}
        </div>
        <div className="campaign__preview">
          { this.state.checkout ? 
            <Checkout /> :
            <SMSPreview state={this.state} />
          }
        </div>
      </div>
    )
  }
}

export default SMSCampaign


// WEBPACK FOOTER //
// ./src/components/campaigns/SMSCampaign.js